export class TileNavigationStateSynchronizer {
    constructor(source, target, enabled = true) {
        this._source = source;
        this._target = target;
        this._enabled = enabled;
        this._sourceChangedObserver = this._source.validationObservable?.add(this._onSourceValidation.bind(this));
        this._propertyChangedObserver = this._source.propertyChangedObservable.add(this._onSourcePropertyChanged.bind(this));
    }
    dispose() {
        this._sourceChangedObserver?.disconnect();
        this._propertyChangedObserver?.disconnect();
    }
    get source() {
        return this._source;
    }
    get target() {
        return this._target;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(v) {
        this._enabled = v;
    }
    _onSourceValidation(state, eventState) {
        if (state && this._enabled) {
            this._target.validate();
        }
    }
    _onSourcePropertyChanged(property, eventState) {
        if (this._enabled && property.propertyName) {
            this._target[property.propertyName] = property.newValue;
        }
    }
}
//# sourceMappingURL=tiles.navigation.state.sync.js.map